import { render, staticRenderFns } from "./purchaseCourse.vue?vue&type=template&id=5128dbc0&scoped=true"
import script from "./purchaseCourse.vue?vue&type=script&lang=js"
export * from "./purchaseCourse.vue?vue&type=script&lang=js"
import style0 from "./purchaseCourse.vue?vue&type=style&index=0&id=5128dbc0&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128dbc0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5128dbc0')) {
      api.createRecord('5128dbc0', component.options)
    } else {
      api.reload('5128dbc0', component.options)
    }
    module.hot.accept("./purchaseCourse.vue?vue&type=template&id=5128dbc0&scoped=true", function () {
      api.rerender('5128dbc0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/merchantAccount/purchaseCourse.vue"
export default component.exports